import Vue from 'vue';
import Vuex from 'vuex';
import checkout from './checkout';
import course from './course';
import editConnecta from './profile/edit-connecta';
import modals from './modals';
import user from './user';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    checkout,
    course,
    editConnecta,
    modals,
    user,
  },
  getters: {
    userData: (state) => state.user.userData,
  },
});
